import { memo } from 'react';
import { Calendar } from 'lucide-react';
import { BaseNodeUI } from './BaseNodeUI';

export const DateNode = memo(({ data, selected }: any) => {
    return (
        <BaseNodeUI
            selected={selected}
            icon={Calendar}
            title="Date Utils"
            colorClass="text-rose-600"
            bgClass="bg-rose-50"
        >
            <div className="text-[9px] text-slate-400 mt-0.5 leading-none">
                {(data.transforms && data.transforms.length > 0)
                    ? `${data.transforms.length} Ops`
                    : 'Configure'}
            </div>
        </BaseNodeUI>
    );
});
